/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InterventionPlanningResource } from '../models/InterventionPlanningResource';
import type { InterventionRequest } from '../models/InterventionRequest';
import type { InterventionResource } from '../models/InterventionResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InterventionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Interventions SAV a planifier
     * Reserve aux techniciens : les interventions de type SAV non terminees et non planifiees, de la plus recente a la plus ancienne. Chacune peut etre prise en charge avec `interventions/{id}/prendre-en-charge`.
     * @returns InterventionResource Array of `InterventionResource`
     * @throws ApiError
     */
    public interventionGetNonPlanifiees(): CancelablePromise<Array<InterventionResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/interventions/non-planifiees',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Prendre en charge une intervention
     * Reserve aux techniciens. Planifie l'intervention pour le technicien connecte a partir de la prochaine demi-heure, pour sa duree prevue (1 h par defaut), et la lui affecte. Refuse si l'intervention est deja planifiee. Renvoie le creneau cree.
     * @param id
     * @returns InterventionPlanningResource `InterventionPlanningResource`
     * @throws ApiError
     */
    public interventionPrendreEnCharge(
        id: string,
    ): CancelablePromise<InterventionPlanningResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/interventions/{id}/prendre-en-charge',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Interventions d'une periode
     * Entre `DATE_DEBUT` et `DATE_FIN`, selon le profil : `TYPE=commercial` renvoie les interventions des projets du commercial, `TYPE=metreur` celles a metrer, sinon le planning du technicien connecte (ou de `user_id_impersonate`).
     * @param dateDebut
     * @param dateFin
     * @returns InterventionPlanningResource Array of `InterventionPlanningResource`
     * @throws ApiError
     */
    public interventionsIndex(
        dateDebut: string,
        dateFin?: string | null,
    ): CancelablePromise<Array<InterventionPlanningResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/interventions',
            query: {
                'DATE_DEBUT': dateDebut,
                'DATE_FIN': dateFin,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer une intervention
     * @param requestBody
     * @returns InterventionResource `InterventionResource`
     * @throws ApiError
     */
    public interventionsStore(
        requestBody: InterventionRequest,
    ): CancelablePromise<InterventionResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/interventions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'une intervention
     * Avec les lignes de devis concernees, la quincaillerie, les creneaux planifies, le projet (client, adresse de chantier) et le devis.
     * @param id
     * @returns InterventionResource `InterventionResource`
     * @throws ApiError
     */
    public interventionsShow(
        id: string,
    ): CancelablePromise<InterventionResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/interventions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Supprimer une intervention (non disponible)
     * La suppression d'une intervention n'est pas autorisee : l'appel est toujours refuse.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public interventionsDestroy(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/interventions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Modifier une intervention
     * Mise a jour partielle : seuls les champs envoyes changent.
     * @param idIntervention
     * @param requestBody
     * @returns InterventionResource `InterventionResource`
     * @throws ApiError
     */
    public interventionsUpdate(
        idIntervention: string,
        requestBody: InterventionRequest,
    ): CancelablePromise<InterventionResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/interventions/{id_intervention}',
            path: {
                'id_intervention': idIntervention,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Generer le proces-verbal d'intervention
     * Produit le PV au format PDF (projet, commande, techniciens, creneaux, points de controle `checkboxes`, signatures client `signImage` et technicien `signImageTec`, `nature`, texte de conclusion `finishingText`), le range dans les fichiers de l'intervention avec le tag `pv-reception` et marque l'intervention terminee. L'intervention doit avoir un devis, un projet et au moins un creneau planifie.
     *
     * Reponse : `{ message, details: { file_name, url, data } }` — `url` est valable 30 minutes.
     * @param idIntervention
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public interventionGeneratePdf(
        idIntervention: string,
        requestBody: {
            signImage: string | null;
            nature: string | null;
            signImageTec: string | null;
            finishingText?: string | null;
            checkboxes: Array<boolean>;
        },
    ): CancelablePromise<{
        message: string;
        details: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/intervention/{id_intervention}/pdf',
            path: {
                'id_intervention': idIntervention,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Envoyer un PV par e-mail
     * Envoie le fichier `file_name` en piece jointe (nommee `display_name`) a `recipient_emails`, au nom de `sender_name`, avec le lien d'avis Google de l'entreprise s'il est configure. 400 avec le message en cas d'echec.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public interventionSendPvEmail(
        requestBody: {
            recipient_name: string;
            sender_name: string;
            file_name: string;
            display_name: string;
            recipient_emails: string;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/intervention/send',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
